import { useTranslation } from 'react-i18next';
import { PageHeader } from '../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../layout';
import { ScheduledActionsTable } from './components/ScheduledActionsTable';

export const ScheduledActions = () => {
  const { t } = useTranslation('page-admin-my-tasks');
  return (
    <PageLayout>
      <PageHeader backRouteTo={''} title={t('title')} />
      <PageContent sx={{ alignItems: 'flex-start' }}>
        <ScheduledActionsTable />
      </PageContent>
    </PageLayout>
  );
};
